export default class CryptoUtil {
  static encode(data): any {
    return btoa(data);
  }
}
